export class GearTweenConfig {
    constructor() {
        this.enabled = true;
        this.easeType = "quadOut";
        this.duration = 300;
        this.delay = 0;
    }
}
